import * as AOS from 'aos';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { APP_CONFIG } from '../../config/config';
import { SeoService } from '../../services/seo.service';
import { AppState } from '@app/store/states/app.states';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { CoreService } from '../../services/core.service';
import { FAQCategories } from '../../services/faqs.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as AppActions from '@app/store/actions/app.actions';
import { IAppConfig } from '@app/store/models/config.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FunctionsService } from '../../services/functions.service';
import { selectAppState } from '@app/store/selectors/app.selectors';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { QrGeneratorNavigator } from '@app/store/models/qr-generator-navigator.interface';
import { QrGeneratorNavigatorSteps } from '@app/store/enums/qr-generator-navigator-steps.enum';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';
import { QrGeneratorNavigatorSMSForm } from '@app/store/models/qr-generator-navigator-sms.interface';
import { QrGeneratorNavigatorURLForm } from '@app/store/models/qr-generator-navigator-url.interface';
import { QrGeneratorNavigatorTEXTForm } from '@app/store/models/qr-generator-navigator-text.interface';
import { QrGeneratorNavigatorWiFiForm } from '@app/store/models/qr-generator-navigator-wifi.interface';
import { QrGeneratorNavigatorVCARDForm } from '@app/store/models/qr-generator-navigator-vcard.interface';
import { QrGeneratorNavigatorEMAILForm } from '@app/store/models/qr-generator-navigator-email.interface';
import { QrGeneratorNavigatorBitcoinsForm } from '@app/store/models/qr-generator-navigator-bitcoins.interface';
import { QrGeneratorNavigatorLOCATIONForm } from '@app/store/models/qr-generator-navigator-location-category.interface';
import { QrGeneratorNavigatorBitcoins, QrGeneratorNavigatorCategories, QrGeneratorNavigatorEMAIL, QrGeneratorNavigatorLOCATION, QrGeneratorNavigatorSMS, QrGeneratorNavigatorTEXT, QrGeneratorNavigatorURL, QrGeneratorNavigatorVCARD, QrGeneratorNavigatorWIFI, QrThemeCornerOptions, WiFiEncryptionTypes, shuffleArray } from 'shared-library';

@Component({
    selector: 'app-core-welcome',
    templateUrl: './core-welcome.component.html',
    styleUrls: ['./core-welcome.component.scss']
})
export class CoreWelcomeComponent implements OnInit {

    categories: QRCodePublicCategory[] = [
        {
            text: "URL",
            icon: "bi bi-globe2",
            href: "branded-qr-code-for-url",
            category: QrGeneratorNavigatorCategories.URL,
            alternate_urls: [
                `branded-qr-code-for-url`,
                QrGeneratorNavigatorCategories.URL,
                QrGeneratorNavigatorCategories.WEBSITE,
            ]
        },
        {
            text: "WiFi",
            icon: "bi bi-wifi",
            href: "branded-qr-code-for-wifi",
            category: QrGeneratorNavigatorCategories.WIFI,
            alternate_urls: [
                `branded-qr-code-for-wifi`,
                QrGeneratorNavigatorCategories.WIFI
            ]
        },
        {
            text: "vCard",
            icon: "bi bi-person",
            href: "branded-qr-code-for-vcard",
            category: QrGeneratorNavigatorCategories.VCARD,
            alternate_urls: [
                `branded-qr-code-for-vcard`,
                QrGeneratorNavigatorCategories.VCARD
            ]
        },
        {
            text: "Email",
            icon: "bi bi-envelope",
            href: "branded-qr-code-for-email",
            category: QrGeneratorNavigatorCategories.EMAIL,
            alternate_urls: [
                `branded-qr-code-for-email`,
                QrGeneratorNavigatorCategories.EMAIL
            ]
        },
        {
            href: "branded-qr-code-for-sms",
            text: "SMS",
            icon: "bi bi-chat-left-dots",
            category: QrGeneratorNavigatorCategories.SMS,
            alternate_urls: [
                `branded-qr-code-for-sms`,
                QrGeneratorNavigatorCategories.SMS
            ]
        },
        {
            href: "branded-qr-code-for-text",
            text: "Text",
            icon: "bi bi-blockquote-left",
            category: QrGeneratorNavigatorCategories.TEXT,
            alternate_urls: [
                `branded-qr-code-for-text`,
                QrGeneratorNavigatorCategories.TEXT
            ]
        },
        {
            text: "Bitcoin",
            icon: "bi bi-currency-bitcoin",
            href: "branded-qr-code-for-bitcoin",
            category: QrGeneratorNavigatorCategories.BITCOIN,
            alternate_urls: [
                `branded-qr-code-for-bitcoin`,
                QrGeneratorNavigatorCategories.BITCOIN
            ]
        },
        {
            text: "Location",
            icon: "bi bi-geo-alt",
            href: "branded-qr-code-location",
            category: QrGeneratorNavigatorCategories.LOCATION,
            alternate_urls: [
                `branded-qr-code-location`,
                QrGeneratorNavigatorCategories.LOCATION
            ]
        },
        {
            text: "Memories",
            icon: "bi bi-camera",
            href: "branded-qr-code-for-memories",
            category: QrGeneratorNavigatorCategories.MEMORIES,
            alternate_urls: [
                `branded-qr-code-for-weddings`,
                `branded-qr-code-for-memories`,
                QrGeneratorNavigatorCategories.MEMORIES
            ]
        },
        {
            text: "Restaurant Menu",
            icon: "bi bi-menu-app",
            href: "branded-qr-code-for-restaurant-menu",
            category: QrGeneratorNavigatorCategories.RESTAURANT_MENU,
            alternate_urls: [
                `menu`,
                `restaurant`,
                `branded-qr-code-for-restaurant-menu`,
                QrGeneratorNavigatorCategories.RESTAURANT_MENU
            ]
        },
        {
            text: "Images",
            icon: "bi bi-images",
            href: "branded-qr-code-for-images",
            category: QrGeneratorNavigatorCategories.IMAGES,
            alternate_urls: [
                `image`,
                `photo`,
                `photos`,
                `image-gallery`,
                `branded-qr-code-for-image`,
                `branded-qr-code-for-photo`,
                `branded-qr-code-for-photos`,
                `branded-qr-code-for-images`,
                `branded-qr-code-for-image-gallery`,
                QrGeneratorNavigatorCategories.IMAGES
            ]
        },
        {
            text: "PDF",
            icon: "bi bi-file-earmark-pdf",
            href: "branded-qr-code-for-pdf",
            category: QrGeneratorNavigatorCategories.PDF,
            alternate_urls: [
                `branded-qr-code-for-pdf`,
                QrGeneratorNavigatorCategories.PDF
            ]
        },
        {
            text: "vCard Pro",
            icon: "bi bi-person-badge",
            href: "branded-qr-code-for-vcard-pro",
            category: QrGeneratorNavigatorCategories.VCARD_PRO,
            alternate_urls: [
                `branded-qr-code-for-vcard-pro`,
                QrGeneratorNavigatorCategories.VCARD_PRO,
                `branded-qr-code-for-digital-business-card`,
            ]
        },
        {
            text: "Pet Tag",
            icon: "bi bi-tags",
            href: "branded-qr-code-for-pet-tag",
            category: QrGeneratorNavigatorCategories.PET,
            alternate_urls: [
                `pets`,
                `branded-qr-code-for-pet`,
                `branded-qr-code-for-pet-tag`,
                `branded-qr-code-for-pet-tags`,
                QrGeneratorNavigatorCategories.PET
            ]
        },
        {
            text: "Business Page",
            icon: "bi bi-building",
            href: "branded-qr-code-for-business-page",
            category: QrGeneratorNavigatorCategories.BUSINESS_PAGE,
            alternate_urls: [
                `business-pages`,
                `branded-qr-code-for-business-page`,
                `branded-qr-code-for-business-pages`,
                QrGeneratorNavigatorCategories.BUSINESS_PAGE
            ]
        },
        {
            text: "Social Media",
            icon: "bi bi-megaphone",
            href: "branded-qr-code-for-social-media-accounts",
            category: QrGeneratorNavigatorCategories.SOCIAL_MEDIA,
            alternate_urls: [
                `social-media-account`,
                `branded-qr-code-for-social-media`,
                `branded-qr-code-for-social-media-accounts`,
                QrGeneratorNavigatorCategories.SOCIAL_MEDIA
            ]
        },
        {
            text: "Coupons",
            icon: "bi bi-percent",
            href: "branded-qr-code-for-coupons",
            category: QrGeneratorNavigatorCategories.COUPONS,
            alternate_urls: [
                `coupon`,
                `branded-qr-code-for-coupon`,
                `branded-qr-code-for-coupons`,
                QrGeneratorNavigatorCategories.COUPONS
            ]
        },
        {
            text: "Feedback",
            icon: "bi bi-chat-dots",
            href: "branded-qr-code-for-feedback",
            category: QrGeneratorNavigatorCategories.FEEDBACK,
            alternate_urls: [
                `feedbacks`,
                `branded-qr-code-for-feedback`,
                `branded-qr-code-for-feedbacks`,
                QrGeneratorNavigatorCategories.FEEDBACK
            ]
        },
        {
            text: "Rating",
            icon: "bi bi-star",
            href: "branded-qr-code-for-rating",
            category: QrGeneratorNavigatorCategories.RATING,
            alternate_urls: [
                `ratings`,
                `reviews`,
                `branded-qr-code-for-rating`,
                `branded-qr-code-for-review`,
                `branded-qr-code-for-reviews`,
                `branded-qr-code-for-ratings`,
                QrGeneratorNavigatorCategories.RATING
            ]
        },
        {
            text: "YouTube Videos",
            icon: "bi bi-youtube",
            href: "branded-qr-code-for-youtube-videos",
            category: QrGeneratorNavigatorCategories.VIDEOS,
            alternate_urls: [
                `video`,
                `youtube-video`,
                `youtube-videos`,
                `branded-qr-code-for-youtube-video`,
                `branded-qr-code-for-youtube-videos`,
                QrGeneratorNavigatorCategories.VIDEOS
            ]
        },
        {
            text: "Event",
            icon: "bi bi-calendar-check",
            href: "branded-qr-code-for-event",
            category: QrGeneratorNavigatorCategories.EVENT,
            alternate_urls: [
                `events`,
                `branded-qr-code-for-event`,
                `branded-qr-code-for-events`,
                QrGeneratorNavigatorCategories.EVENT
            ]
        },
        {
            text: "Vacancy",
            icon: "bi bi-briefcase",
            href: "branded-qr-code-for-vacancy",
            category: QrGeneratorNavigatorCategories.VACANCY,
            alternate_urls: [
                `vacancies`,
                `branded-qr-code-for-vacancy`,
                `branded-qr-code-for-vacancies`,
                QrGeneratorNavigatorCategories.VACANCY
            ]
        },

        {
            text: "APP",
            icon: "bi bi-app-indicator",
            href: "branded-qr-code-for-mobile-app",
            category: QrGeneratorNavigatorCategories.APP,
            alternate_urls: [
                `branded-qr-code-for-app`,
                `branded-qr-code-for-apps`,
                `branded-qr-code-for-mobile-app`,
                QrGeneratorNavigatorCategories.APP,
                `branded-qr-code-for-mobile-application`,
                `branded-qr-code-for-mobile-app-download`
            ]
        },
        {
            text: "MP3",
            href: "branded-qr-code-for-mp3",
            icon: "bi bi-music-note-beamed",
            category: QrGeneratorNavigatorCategories.MP3,
            alternate_urls: [
                `branded-qr-code-for-mp3`,
                QrGeneratorNavigatorCategories.MP3
            ]
        },
        {
            text: "Long Text",
            icon: "bi bi-file-richtext",
            href: "branded-qr-code-for-long-text",
            category: QrGeneratorNavigatorCategories.LONG_PLAIN_TEXT,
            alternate_urls: [
                `branded-qr-code-for-long-text`,
                QrGeneratorNavigatorCategories.LONG_PLAIN_TEXT
            ]
        }
    ]

    static_categories: QRCodePublicCategory[] = this.categories.slice(0, 8)
    dynamic_categories: QRCodePublicCategory[] = this.categories.slice(8)

    private readonly allProductUseCases = this.coreService.allProductUseCases()
    readonly pdf_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.PDF === perfect_for).map(({ title }) => title))
    readonly app_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.APP === perfect_for).map(({ title }) => title))
    readonly mp3_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.MP3 === perfect_for).map(({ title }) => title))
    readonly pet_tag_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.PET === perfect_for).map(({ title }) => title))
    readonly events_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.EVENT === perfect_for).map(({ title }) => title))
    readonly images_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.IMAGES === perfect_for).map(({ title }) => title))
    readonly rating_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.RATING === perfect_for).map(({ title }) => title))
    readonly videos_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.VIDEOS === perfect_for).map(({ title }) => title))
    readonly coupons_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.COUPONS === perfect_for).map(({ title }) => title))
    readonly feedback_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.FEEDBACK === perfect_for).map(({ title }) => title))
    readonly vacancies_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.VACANCY === perfect_for).map(({ title }) => title))
    readonly memories_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.MEMORIES === perfect_for).map(({ title }) => title))
    readonly vcard_pro_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.VCARD_PRO === perfect_for).map(({ title }) => title))
    readonly social_media_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.SOCIAL_MEDIA === perfect_for).map(({ title }) => title))
    readonly business_page_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.BUSINESS_PAGE === perfect_for).map(({ title }) => title))
    readonly restaurant_menu_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.RESTAURANT_MENU === perfect_for).map(({ title }) => title))
    readonly long_plain_text_uses_cases_titles = shuffleArray(this.allProductUseCases.filter(({ perfect_for }) => QrGeneratorNavigatorCategories.LONG_PLAIN_TEXT === perfect_for).map(({ title }) => title))

    data_form_for_sms: FormGroup<QrGeneratorNavigatorSMSForm>
    data_form_for_url: FormGroup<QrGeneratorNavigatorURLForm>
    data_form_for_text: FormGroup<QrGeneratorNavigatorTEXTForm>
    data_form_for_wifi: FormGroup<QrGeneratorNavigatorWiFiForm>
    data_form_for_email: FormGroup<QrGeneratorNavigatorEMAILForm>
    data_form_for_vcard: FormGroup<QrGeneratorNavigatorVCARDForm>
    data_form_for_bitcoin: FormGroup<QrGeneratorNavigatorBitcoinsForm>
    data_form_for_location: FormGroup<QrGeneratorNavigatorLOCATIONForm>

    session_info: SessionInfo
    qr_generator: QrGeneratorNavigator
    cryptocurrencies = this.qrGeneratorService.getCryptoCurrencies()
    selected_category_obs: Subject<QrGeneratorNavigatorCategories> = new Subject<QrGeneratorNavigatorCategories>()

    private route_category: string
    private subscriptions: Subscription[] = []
    selected_category = QrGeneratorNavigatorCategories.URL
    all_categories = this.qrGeneratorService.getAllCategoriesObj()

    encryptions = {
        WPA: WiFiEncryptionTypes.WPA,
        WEP: WiFiEncryptionTypes.WEP,
        NONE: WiFiEncryptionTypes.NONE,
    }

    categories_obj = {
        LANDING_PAGE: FAQCategories.LANDING_PAGE
    }

    app_state: AppState
    appState$ = this.store.select(selectAppState);

    constructor(
        private store: Store,
        private router: Router,
        private seo: SeoService,
        private formBuilder: FormBuilder,
        private coreService: CoreService,
        private device: DeviceDetectorService,
        private activatedRoute: ActivatedRoute,
        private functionService: FunctionsService,
        private qrGeneratorService: UserQrGeneratorService,
        @Inject(APP_CONFIG) private readonly config: IAppConfig
    ) {
        this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
        this.subscriptions.push(this.appState$.subscribe(ls => this.app_state = ls))
    }

    ngOnInit(): void {
        AOS.init({
            offset: 200,
            duration: 1000
        });
        this.subscriptions.push(this.activatedRoute.params.subscribe(params => {
            this.route_category = params['category']
            this.setFormBuilder()
        }));
        this.store.dispatch(AppActions.fetchSubscriptionPrices({ url: this.config.apiEndpoints.resources.pricings }))
        this.store.dispatch(AppActions.fetchAlaCartePrices({ qr_category: QrGeneratorNavigatorCategories.MEMORIES }))
    }

    ngOnDestroy(): void {
        this.subscriptions.map(s => s.unsubscribe())
    }

    private setFormBuilder() {
        if (!this.session_info) return
        const category = this.categories.find(category => category.alternate_urls.includes(this.route_category))
        if (!category?.category && this.route_category) {
            this.router.navigateByUrl("/404")
            return
        }

        this.session_info.last_routes.new_home = `/`
        this.selected_category = QrGeneratorNavigatorCategories.URL
        if (category?.category) {
            this.selected_category = category.category
            this.session_info.last_routes.new_home = `/${category.href}`
        }

        if (this.route_category) {
            this.functionService.scrollToTop(".qr-content-container")
        }
        this.selected_category_obs.next(this.selected_category)
        this.qr_generator = this.session_info.qr_generating.drafts.find(d => d.selected_category === this.selected_category)

        if (!this.qr_generator) {
            this.qr_generator = this.qrGeneratorService.initQRCreatorData(this.selected_category)
            this.qr_generator.style_settings.qr_style.dotsOptions.type = QrThemeCornerOptions.ROUNDED
            this.qr_generator.style_settings.qr_style.cornersSquareOptions.type = QrThemeCornerOptions.EXTRA_ROUNDED
        }
        this.functionService.initializeTooltip()
        this.seo.generateMetaTags(this.qr_generator.selected_category)

        const urlRegex = this.functionService.urlRegex()
        const mobileRegex = this.functionService.mobileRegex()
        const latitudeRegex = this.functionService.latitudeRegex()
        const longitudeRegex = this.functionService.longitudeRegex()

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.URL) {
            if (!this.qr_generator.url_data) {
                this.qr_generator.url_data = this.qrGeneratorService.initWEBSITECategoryData()
            }

            this.data_form_for_url = this.formBuilder.group({
                qr_name: [this.qr_generator.url_data.qr_name],
                url: [this.qr_generator.url_data.url, [Validators.required, Validators.pattern(urlRegex)]],
            });
            this.subscriptions.push(this.data_form_for_url.valueChanges.subscribe(value => this.saveProgress(false)))

        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.LOCATION) {
            if (!this.qr_generator.location_data) {
                this.qr_generator.location_data = this.qrGeneratorService.initLocationCategoryData(false)
            }

            this.data_form_for_location = this.formBuilder.group({
                qr_name: [this.qr_generator.location_data.qr_name],
                url: [this.qr_generator.location_data.url, [Validators.required, Validators.pattern(urlRegex)]],
                use_lat_long: [this.qr_generator.location_data.use_lat_long],
                latitude: [this.qr_generator.location_data.latitude, this.qr_generator.location_data.use_lat_long ? [Validators.required, Validators.pattern(latitudeRegex)] : Validators.nullValidator],
                longitude: [this.qr_generator.location_data.longitude, this.qr_generator.location_data.use_lat_long ? [Validators.required, Validators.pattern(longitudeRegex)] : Validators.nullValidator],
                location: this.formBuilder.group({
                    address: [this.qr_generator.location_data.location.address],
                    location_url: [this.qr_generator.location_data.location.location_url],
                    from_form: [this.qr_generator.location_data.location.from_form],
                    form: this.formBuilder.group({
                        zip: [this.qr_generator.location_data.location.form.zip],
                        city: [this.qr_generator.location_data.location.form.city],
                        state: [this.qr_generator.location_data.location.form.state],
                        street: [this.qr_generator.location_data.location.form.street],
                        country: [this.qr_generator.location_data.location.form.country],
                    }),
                    google: this.formBuilder.group({
                        url: [this.qr_generator.location_data.location.google.url],
                        lat: [this.qr_generator.location_data.location.google.lat],
                        long: [this.qr_generator.location_data.location.google.long],
                        rating: [this.qr_generator.location_data.location.google.rating],
                        formatted_address: [this.qr_generator.location_data.location.google.formatted_address],
                        international_phone_number: [this.qr_generator.location_data.location.google.international_phone_number],
                    }),
                }),
            });
            this.subscriptions.push(this.data_form_for_location.valueChanges.subscribe(value => this.saveProgress(false)))
            this.subscriptions.push(this.data_form_for_location.controls.latitude.valueChanges.subscribe(latitude => {
                const cControl1 = this.data_form_for_location.get('url');
                const longitude = this.data_form_for_location.controls.longitude.value
                cControl1.setValue(this.functionService.generateMapUrl(latitude, longitude))
                cControl1.updateValueAndValidity();
            }))
            this.subscriptions.push(this.data_form_for_location.controls.longitude.valueChanges.subscribe(longitude => {
                const cControl1 = this.data_form_for_location.get('url');
                const latitude = this.data_form_for_location.controls.latitude.value
                cControl1.setValue(this.functionService.generateMapUrl(latitude, longitude))
                cControl1.updateValueAndValidity();
            }))
        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.BITCOIN) {
            if (!this.qr_generator.bitcoin_data) {
                this.qr_generator.bitcoin_data = this.qrGeneratorService.initBitcoinsCategoryData()
            }

            this.data_form_for_bitcoin = this.formBuilder.group({
                qr_name: [this.qr_generator.bitcoin_data.qr_name],
                message: [this.qr_generator.bitcoin_data.message],
                cryptocurrency: [this.qr_generator.bitcoin_data.cryptocurrency],
                address: [this.qr_generator.bitcoin_data.address, [Validators.required]],
                amount: [this.qr_generator.bitcoin_data.amount, [Validators.required, Validators.min(0)]],
            });
            this.subscriptions.push(this.data_form_for_bitcoin.valueChanges.subscribe(value => this.saveProgress(false)))

        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.WIFI) {
            if (!this.qr_generator.wifi_data) {
                this.qr_generator.wifi_data = this.qrGeneratorService.initWiFiCategoryData()
            }

            this.data_form_for_wifi = this.formBuilder.group({
                hidden: [this.qr_generator.wifi_data.hidden],
                qr_name: [this.qr_generator.wifi_data.qr_name],
                encryption: [this.qr_generator.wifi_data.encryption],
                ssid: [this.qr_generator.wifi_data.ssid, [Validators.required]],
                password: [this.qr_generator.wifi_data.password, [Validators.required]],
            });
            this.subscriptions.push(this.data_form_for_wifi.valueChanges.subscribe(value => this.saveProgress(false)))

        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.EMAIL) {
            if (!this.qr_generator.email_data) {
                this.qr_generator.email_data = this.qrGeneratorService.initEMAILCategoryData()
            }
            this.data_form_for_email = this.formBuilder.group({
                body: [this.qr_generator.email_data.body],
                qr_name: [this.qr_generator.email_data.qr_name],
                subject: [this.qr_generator.email_data.subject, Validators.required],
                email: [this.qr_generator.email_data.email, [Validators.required, Validators.email]],
            });
            this.subscriptions.push(this.data_form_for_email.valueChanges.subscribe(value => this.saveProgress(false)))
        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.SMS) {
            if (!this.qr_generator.sms_data) {
                this.qr_generator.sms_data = this.qrGeneratorService.initSMSCategoryData()
            }
            this.data_form_for_sms = this.formBuilder.group({
                body: [this.qr_generator.sms_data.body],
                qr_name: [this.qr_generator.sms_data.qr_name],
                mobile: [this.qr_generator.sms_data.mobile, [Validators.required, Validators.pattern(mobileRegex)]],
            });
            this.subscriptions.push(this.data_form_for_sms.valueChanges.subscribe(value => this.saveProgress(false)))
        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.TEXT) {
            if (!this.qr_generator.text_data) {
                this.qr_generator.text_data = this.qrGeneratorService.initTEXTCategoryData()
            }
            this.data_form_for_text = this.formBuilder.group({
                qr_name: [this.qr_generator.text_data.qr_name],
                text: [this.qr_generator.text_data.text, [Validators.required]],
            });
            this.subscriptions.push(this.data_form_for_text.valueChanges.subscribe(value => this.saveProgress(false)))
        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.URL) {
            if (!this.qr_generator.url_data) {
                this.qr_generator.url_data = this.qrGeneratorService.initURLCategoryData()
            }
            this.data_form_for_url = this.formBuilder.group({
                qr_name: [this.qr_generator.url_data.qr_name],
                url: [this.qr_generator.url_data.url, [Validators.required, Validators.pattern(urlRegex)]],
            });
            this.subscriptions.push(this.data_form_for_url.valueChanges.subscribe(value => this.saveProgress(false)))
        }

        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.VCARD) {
            if (!this.qr_generator.vcard_data) {
                this.qr_generator.vcard_data = this.qrGeneratorService.initVCardCategoryData()
            }
            this.data_form_for_vcard = this.formBuilder.group({
                note: [this.qr_generator.vcard_data.note],
                title: [this.qr_generator.vcard_data.title],
                qr_name: [this.qr_generator.vcard_data.qr_name],
                address: [this.qr_generator.vcard_data.address],
                birthday: [this.qr_generator.vcard_data.birthday],
                location: this.formBuilder.group({
                    address: [this.qr_generator.vcard_data.location.address],
                    from_form: [this.qr_generator.vcard_data.location.from_form],
                    location_url: [this.qr_generator.vcard_data.location.location_url],
                    form: this.formBuilder.group({
                        zip: [this.qr_generator.vcard_data.location.form.zip],
                        city: [this.qr_generator.vcard_data.location.form.city],
                        state: [this.qr_generator.vcard_data.location.form.state],
                        street: [this.qr_generator.vcard_data.location.form.street],
                        country: [this.qr_generator.vcard_data.location.form.country],
                    }),
                    google: this.formBuilder.group({
                        url: [this.qr_generator.vcard_data.location.google.url],
                        lat: [this.qr_generator.vcard_data.location.google.lat],
                        long: [this.qr_generator.vcard_data.location.google.long],
                        rating: [this.qr_generator.vcard_data.location.google.rating],
                        formatted_address: [this.qr_generator.vcard_data.location.google.formatted_address],
                        international_phone_number: [this.qr_generator.vcard_data.location.google.international_phone_number],
                    }),
                }),
                mobile_work: [this.qr_generator.vcard_data.mobile_work],
                designation: [this.qr_generator.vcard_data.designation],
                company_name: [this.qr_generator.vcard_data.company_name],
                mobile_other: [this.qr_generator.vcard_data.mobile_other],
                email: [this.qr_generator.vcard_data.email, Validators.email],
                show_profile_url: [this.qr_generator.vcard_data.show_profile_url],
                full_name: [this.qr_generator.vcard_data.full_name, Validators.required],
                website: [this.qr_generator.vcard_data.website, Validators.pattern(urlRegex)],
                mobile: [this.qr_generator.vcard_data.mobile, [Validators.required, Validators.pattern(mobileRegex)]],
                profile_url: [this.qr_generator.vcard_data.profile_url, [this.qr_generator.vcard_data.show_profile_url ? Validators.required : Validators.nullValidator, Validators.pattern(urlRegex)]],
            });
            this.subscriptions.push(this.data_form_for_vcard.get('show_profile_url').valueChanges.subscribe(value => {
                const urlControl = this.data_form_for_vcard.get('profile_url');
                if (value === true) {
                    urlControl.setValidators([Validators.required, Validators.pattern(urlRegex)]);
                } else {
                    urlControl.clearValidators();
                }
                urlControl.updateValueAndValidity();
            }))
            this.subscriptions.push(this.data_form_for_vcard.valueChanges.subscribe(value => this.saveProgress(false)))
        }
        this.saveProgress(false)
    }

    generateQr() {

        switch (this.qr_generator.selected_category) {
            case QrGeneratorNavigatorCategories.URL:
                this.data_form_for_url.markAllAsTouched()
                if (!this.data_form_for_url.valid) {
                    this.functionService.logToConsole(this.data_form_for_url.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            case QrGeneratorNavigatorCategories.BITCOIN:
                this.data_form_for_bitcoin.markAllAsTouched()
                if (!this.data_form_for_bitcoin.valid) {
                    this.functionService.logToConsole(this.data_form_for_bitcoin.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            case QrGeneratorNavigatorCategories.LOCATION:
                this.data_form_for_location.markAllAsTouched()
                if (!this.data_form_for_location.valid) {
                    this.functionService.logToConsole(this.data_form_for_location.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            case QrGeneratorNavigatorCategories.WIFI:
                this.data_form_for_wifi.markAllAsTouched()
                if (!this.data_form_for_wifi.valid) {
                    this.functionService.logToConsole(this.data_form_for_wifi.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            case QrGeneratorNavigatorCategories.EMAIL:
                this.data_form_for_email.markAllAsTouched()
                if (!this.data_form_for_email.valid) {
                    this.functionService.logToConsole(this.data_form_for_email.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            case QrGeneratorNavigatorCategories.TEXT:
                this.data_form_for_text.markAllAsTouched()
                if (!this.data_form_for_text.valid) {
                    this.functionService.logToConsole(this.data_form_for_text.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            case QrGeneratorNavigatorCategories.VCARD:
                this.data_form_for_vcard.markAllAsTouched()
                if (!this.data_form_for_vcard.valid) {
                    this.functionService.logToConsole(this.data_form_for_vcard.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            case QrGeneratorNavigatorCategories.SMS:
                this.data_form_for_sms.markAllAsTouched()
                if (!this.data_form_for_sms.valid) {
                    this.functionService.logToConsole(this.data_form_for_sms.errors)
                    this.qrGeneratorService.scrollToFirstInvalidControl()
                    return
                }
                break;
            default:
                return
        }

        this.saveProgress()
    }

    private saveProgress(generate_qr = true) {
        this.qr_generator.qr_url = ""
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.APP) {
            this.qr_generator.app_data = this.qrGeneratorService.initAPPCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.WEBSITE) {
            this.qr_generator.website_data = this.qrGeneratorService.initWEBSITECategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.EVENT) {
            this.qr_generator.event_data = this.qrGeneratorService.initEventCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.COUPONS) {
            this.qr_generator.coupons_data = this.qrGeneratorService.initCouponsCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.BUSINESS_PAGE) {
            this.qr_generator.businesspage_data = this.qrGeneratorService.initBusinessPageCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.RESTAURANT_MENU) {
            this.qr_generator.restaurant_menu_data = this.qrGeneratorService.initRestaurantMenu(this.app_state?.currency)
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.LONG_PLAIN_TEXT) {
            this.qr_generator.long_plain_text_data = this.qrGeneratorService.initLongPlainTextCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.FEEDBACK) {
            this.qr_generator.feedback_data = this.qrGeneratorService.initFeedbackCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.IMAGES) {
            this.qr_generator.images_data = this.qrGeneratorService.initImagesCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.MP3) {
            this.qr_generator.mp3_data = this.qrGeneratorService.initMP3CategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.PDF) {
            this.qr_generator.pdf_data = this.qrGeneratorService.initPDFCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.LOCATION) {
            this.qr_generator.location_data = this.data_form_for_location.value as QrGeneratorNavigatorLOCATION
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.RATING) {
            this.qr_generator.rating_data = this.qrGeneratorService.initRatingCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.SOCIAL_MEDIA) {
            this.qr_generator.socials_data = this.qrGeneratorService.initSocialMediaCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.VACANCY) {
            this.qr_generator.vacancy_data = this.qrGeneratorService.initVacancyCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.VCARD_PRO) {
            this.qr_generator.vcardpro_data = this.qrGeneratorService.initVCardProCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.VIDEOS) {
            this.qr_generator.videos_data = this.qrGeneratorService.initVideoCategoryData()
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.EMAIL) {
            if (generate_qr) generate_qr = this.data_form_for_email.valid
            this.qr_generator.email_data = this.data_form_for_email.value as QrGeneratorNavigatorEMAIL
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.SMS) {
            this.qr_generator.sms_data = this.data_form_for_sms.value as QrGeneratorNavigatorSMS
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.TEXT) {
            this.qr_generator.text_data = this.data_form_for_text.value as QrGeneratorNavigatorTEXT
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.URL) {
            this.qr_generator.url_data = this.data_form_for_url.value as QrGeneratorNavigatorURL
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.VCARD) {
            this.qr_generator.vcard_data = this.data_form_for_vcard.value as QrGeneratorNavigatorVCARD
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.BITCOIN) {
            this.qr_generator.bitcoin_data = this.data_form_for_bitcoin.value as QrGeneratorNavigatorBitcoins
        }
        if (this.qr_generator.selected_category === QrGeneratorNavigatorCategories.WIFI) {
            if (generate_qr) generate_qr = this.data_form_for_wifi.valid
            this.qr_generator.wifi_data = this.data_form_for_wifi.value as QrGeneratorNavigatorWIFI
        }

        if (!this.isFreeCategory()) {
            this.session_info.qr_generating.next_preferred_step = QrGeneratorNavigatorSteps.CUSTOMIZE
        } else {
            delete this.session_info.qr_generating.next_preferred_step
        }

        this.qr_generator.active_step = QrGeneratorNavigatorSteps.START
        this.session_info.qr_generating.last_viewed_category = this.qr_generator.selected_category
        const _index = this.session_info.qr_generating.drafts.findIndex(d => d.selected_category === this.qr_generator.selected_category)
        if (_index === -1)
            this.session_info.qr_generating.drafts.push(this.qr_generator)
        else
            this.session_info.qr_generating.drafts[_index] = this.qr_generator

        if (generate_qr && this.device.isMobile()) {
            this.functionService.scrollToTop(".qr-wrapper")
        }

        this.coreService.setSessionData(this.session_info, generate_qr && this.isFreeCategory())
    }

    isFreeCategory() {
        return [QrGeneratorNavigatorCategories.WEBSITE, QrGeneratorNavigatorCategories.VCARD, QrGeneratorNavigatorCategories.TEXT, QrGeneratorNavigatorCategories.URL, QrGeneratorNavigatorCategories.SMS, QrGeneratorNavigatorCategories.EMAIL, QrGeneratorNavigatorCategories.BITCOIN, QrGeneratorNavigatorCategories.WIFI, QrGeneratorNavigatorCategories.LOCATION].includes(this.qr_generator.selected_category)
    }

}


interface QRCodePublicCategory {
    href: string;
    text: string;
    icon: string;
    alternate_urls: string[];
    category: QrGeneratorNavigatorCategories;
}
